import React from 'react'

import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import KJ from './KJ'
import Header from '../Landing/Header'
import Footer from '../Landing/Footer'
import ReactPlayer from 'react-player/youtube'
import Container from 'react-bootstrap/Container'
import ReactGa from 'react-ga4'
import MusicListenButton from './MusicListenButton'
import Button from 'react-bootstrap/Button'

import songs from './songs'
import _ from 'lodash'
import Shows from './Shows'
import BookingButton from './BookingButton'
import EmailSignUp from '../Marketing/EmailSignup'

const SecretPreview = (props) => {
    return (
        <>
        <Header />
        <Row fluid="true" className="pl-2 pr-2" style={{ minHeight:'83vh' }}>
            <Container>
                <h1 style={{textAlign:'center'}}>USAPrides Exclusive Preview</h1>
                <Row className="p-3 mb-2" >
                    
                    <Col style={{display:'flex',justifyContent:'center'}}>
                        
                        <ReactPlayer 
                                url={'https://www.youtube.com/watch?v=vRpxVybpQL0'}
                                controls={true}
                                config={{
                                    youtube:{
                                            playerVars:{ 
                                            listType:'playlist',
                                            list:'PLEsmJ45uILbXLJjQdnxaLpEtqXa112Szz'
                                        }
                                    }
                                }}
                                width="100%"
                                height="30vw"
                            />
                        
                    </Col>
                </Row>
                <Row>
                    <Col className="p-3">
                        <p>Play the video above or visit <a href="https://www.youtube.com/watch?v=vRpxVybpQL0&list=PLEsmJ45uILbXLJjQdnxaLpEtqXa112Szz">YouTube Video</a> to listen</p>

                        <p>“Make Me Proud, America” was written last weekend in protest of the senseless brutality of ICE agents in cities across the country and the current administration’s push to drive our country into a full authoritarian state powered by isolationism, nativism, and fear. The song is a plea to the American people to wake up, pay attention, and do something if we want to save our country and avoid history repeating.<br></br>I hope you enjoy the demo and would love to hear what you think about the new song: say hello during the festival or send me an email. I look forward to performing it on pride festival stages this year. </p>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-center">
                        <BookingButton propColor="dark" />
                        <p className="h3">info@johnlevengood.com</p>
                    </Col>
                </Row>
                <Row className="d-flex justify-content-center align-items-center">
                    <Col xs={12} md={10} lg={8} xl={8} className="m-5" >
                        <div className="ml-embedded" data-form="faEPof"></div>
                    </Col>
                </Row>
                <Row>
                {/* <Col >
                    <KJ />
                </Col> */}
                <Col style={{display:'flex',justifyContent:'center',alignItems:'flex-start'}}>
                    <Row >
                        <MusicListenButton site="instagram" url="https://instagram.com/johnlevengood" />
                        <MusicListenButton site="apple"/>
                        <MusicListenButton site="spotify"/>
                        <MusicListenButton site="pandora" />
                        <MusicListenButton site="amazon" />
                        <MusicListenButton site="tidal" />
                        <MusicListenButton site="youtube" />
                    </Row>
                </Col>
            </Row>
            </Container>
        </Row>
        
        <Footer />
        </>
    )
}

export default SecretPreview